import React from 'react';
import { Chip } from '@heroui/react';
import { Icon } from '@iconify/react';
import { useOnlineStatus } from '../utils/lazyWithRetry';

export const OfflineIndicator: React.FC = () => {
  const isOnline = useOnlineStatus();
  const [showOffline, setShowOffline] = React.useState(false);

  React.useEffect(() => {
    if (!isOnline) {
      setShowOffline(true);
    } else {
      // Delay hiding to show "back online" message briefly
      const timer = setTimeout(() => setShowOffline(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  if (!showOffline) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-in slide-in-from-top">
      <Chip
        color={isOnline ? 'success' : 'warning'}
        variant="shadow"
        size="lg"
        startContent={
          <Icon
            icon={isOnline ? 'lucide:wifi' : 'lucide:wifi-off'}
            width={18}
          />
        }
        className="font-medium px-4 py-2"
      >
        {isOnline ? (
          <>
            <span className="font-bold">آنلاین</span>
            <span className="mx-2">•</span>
            <span className="text-xs">Online</span>
          </>
        ) : (
          <>
            <span className="font-bold">آفلاین</span>
            <span className="mx-2">•</span>
            <span className="text-xs">Offline</span>
          </>
        )}
      </Chip>
    </div>
  );
};

export default OfflineIndicator;
